export const REGISTER_USER = 'REGISTER_USER';
export const USER_DATA = 'USER_DATA';
export const REGISTER_FORM = 'REGISTER_FORM';
export const SIGNUP_DATA = 'SIGNUP_DATA';
export const SET_STEP = 'SET_STEP';
// NOTIFICATIONS
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';

// NEWS FEED
export const GET_FULL_NEWS = 'GET_FULL_NEWS';
export const GET_NEWS_CONTINUATION = 'GET_NEWS_CONTINUATION';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_FLITER = 'SET_FLITER';
export const USE_ALT_PAGE = 'USE_ALT_PAGE';
export const SET_INPUT = 'SET_INPUT';
export const SET_NEWS_SINGLE = 'SET_NEWS_SINGLE';
export const CLEAR_INPUT = 'CLEAR_INPUT';

export const pages = [
  'announcements',
  'shout-outs',
  'quotes',
  'hints',
  'upcoming',
];
export const pageTitles = [
  'ANNOUNCEMENTS',
  'SHOUT OUTS',
  'QUOTES',
  'HINTS',
  'UPCOMING',
];

// Sign-Up
export const SET_MODULES = 'SET_SIGNUP_MODULES';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const ADD_VALUE_TO_CURRENT_QUESTION = 'ADD_VALUE_TO_CURRENT_QUESTION';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_APPS = 'SET_APPS';
export const SET_HABITS = 'SET_HABITS';
export const SHOW_REGISTER_FORM = 'SHOW-REGISTER-FORM';
// Commented out as part of ticket to remove Google SSO
// export const SET_SOCIAL_IDS = 'SET-SOCIAL-IDS';
export const REGISTER_COMPLETED = 'REGISTER-COMPLETED';
export const REGISTER_ERROR = 'REGISTER-ERROR';

export const REQUESTING_REGISTER = 'REQUESTING-REGISTER';
export const MOVE_TO_QUESTION = 'MOVE-TO-QUESTION';
export const SET_BEHAVIOURS = 'SET-BEHAVIOURS';
export const ON_CUSTOM_APP_ADDED = 'ON-CUSTOM-APP-ADDED';

// Groups

export const GET_GROUP_LIST = 'GET_GROUP_LIST';
export const GET_ONE_GROUP = 'GET_ONE_GROUP';
export const GET_MEMBERS_GROUP_SUCCESS = 'GET_MEMBERS_GROUP_SUCCESS';
export const GET_MEMBERS_GROUP_ERROR = 'GET_MEMBERS_GROUP_ERROR';

export const Member = 'Member';

export const BUDDIES_FILTER_STATE = 'gmb-buddies-filter-state';

export const GROUP_STAFF = ['Admin', 'Owner'];

export const DEFAULT_HABITS = {
  DEV: {
    1: 448,
    2: 449,
    3: 451,
    4: 450,
  },
  PROD: {
    1: 659,
    2: 661,
    3: 662,
    4: 660,
  },
};

// Signup

export const SIGNUP_INACTIVE = 'SIGNUP_ACTIVE';
export const SIGNUP_ACTIVE = 'SIGNUP_ACTIVE';
export const SIGNUP_COMPLETED = 'SIGNUP_COMPLETED';
export const UPDATE_SIGNUP_STATUS = 'UPDATE_SIGNUP_STATUS';
export const UPDATE_SIGNUP_EMAIL = 'UPDATE_SIGNUP_EMAIL';
